define(["angular", "../nlgAnalysisTree/nlgAnalysisTree"], function (angular) {
    "use strict";

    return angular.module("nlgBasketModule", ["nlgAnalysisTreeModule"]);
});